<div class="block bg-white shadow-md lg:hidden">
    <div
        class="relative flex flex-row items-center justify-center border-b border-solid border-black border-opacity-10 py-2 dark:border-contrast-yellow">
        <ion-button class="absolute left-0 mr-1" fill="clear">
            <a class="home-link flex items-center gap-2 text-base text-red-500" [routerLink]="'/home' | localize">
                <ion-icon class="text-xl" name="arrow-back-outline" aria-hidden="true"></ion-icon>
            </a>
        </ion-button>
        <h1 class="var-app-light-dark:font-bold text-center text-base font-semibold leading-5">
            {{ 'RETAILERS_TITLE' | translate }}
        </h1>
    </div>
    <article
        class="mb-2 p-2 text-center text-base font-normal leading-[1.25] text-black"
        [innerHTML]="'RETAILERS_PAGE_SIDEBAR_TEXT' | translate"></article>
    <div class="mt-4 grid grid-cols-2 gap-2 px-2" *ngIf="env.USE_RETAILERS_WITH_MENU">
        <ion-button
            class="text-sm"
            *ngFor="let zone of zones"
            [color]="(selectedRegion$ | async) === zone.id ? 'primary' : ''"
            [fill]="(selectedRegion$ | async) === zone.id ? 'solid' : 'outline'"
            (click)="selectRegion(zone.id)"
            expand="block">
            {{ zone.titleKey | translate }}
        </ion-button>
    </div>

    <article
        class="shared-content"
        [innerHTML]="
            env.USE_RETAILERS_WITH_MENU ? (regionContent$ | async | translate) : ('RETAILERS_TEXT' | translate)
        "></article>
</div>

<div class="hidden lg:block">
    <div class="box-border flex w-full bg-white">
        <section class="main-grid mx-auto">
            <div class="sidebar bg-white px-4 pb-4 text-left">
                <div>
                    <h1 class="align-left mb-10 text-4xl">{{ 'RETAILERS_TITLE' | translate }}</h1>
                    <article
                        class="mb-10 text-left text-base font-normal leading-[1.25] text-black dark:filter-yellow"
                        [innerHTML]="'RETAILERS_PAGE_SIDEBAR_TEXT' | translate"></article>
                    <hr class="mb-4 h-px border-0 bg-gray-200 dark:bg-contrast-yellow" />
                    <a class="text-default flex items-center gap-2 text-base" [routerLink]="'/home' | localize">
                        <ion-icon class="text-xl" name="arrow-back-outline" aria-hidden="true"></ion-icon>
                        <span>{{ 'LOCAL_BTN_BACK' | translate }}</span>
                    </a>
                    <hr class="mt-4 h-px border-0 bg-gray-200 dark:bg-contrast-yellow" />
                </div>
            </div>
            <div>
                <div class="mb-6 mt-4 grid grid-cols-4 gap-3 px-4" *ngIf="env.USE_RETAILERS_WITH_MENU">
                    <ion-button
                        *ngFor="let zone of zones"
                        [color]="(selectedRegion$ | async) === zone.id ? 'primary' : ''"
                        [fill]="(selectedRegion$ | async) === zone.id ? 'solid' : 'outline'"
                        (click)="selectRegion(zone.id)"
                        expand="block">
                        {{ zone.titleKey | translate }}
                    </ion-button>
                </div>
                <article
                    class="shared-content px-4"
                    [innerHTML]="
                        env.USE_RETAILERS_WITH_MENU
                            ? (regionContent$ | async | translate)
                            : ('RETAILERS_TEXT' | translate)
                    "></article>
            </div>
        </section>
    </div>
</div>
